import { render, staticRenderFns } from "./VerificationState.vue?vue&type=template&id=d1c1a47e&scoped=true"
import script from "./VerificationState.vue?vue&type=script&lang=js"
export * from "./VerificationState.vue?vue&type=script&lang=js"
import style0 from "./VerificationState.vue?vue&type=style&index=0&id=d1c1a47e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1c1a47e",
  null
  
)

export default component.exports